import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=76cb5b3e&scoped=true"
import script from "./Nodata.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nodata.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=76cb5b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb5b3e",
  null
  
)

export default component.exports